'use client';
import { RadioGroup } from '@headlessui/react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { textVariants } from '@/components/text';

import { RequiredSpan } from '../required';

import RadioButton from './radio';
import {
  RadioButtonOrientation,
  RadioButtonVariant,
  type RadioButtonGroupProps,
} from './radio.types';

const RadioButtonGroup = ({
  name,
  heading,
  options,
  selected,
  variant = RadioButtonVariant.LEFT,
  orientation = RadioButtonOrientation.COLUMN,
  disabled,
  onChange,
  showHeading = false,
  headingVariant = 'h3',
  withImages = false,
  required,
  subheading,
}: RadioButtonGroupProps) => {
  if (options.length === 0) {
    return null;
  }

  return (
    <RadioGroup
      name={name}
      onChange={onChange}
      value={selected}
      {...(disabled && { disabled })}
    >
      {heading ? (
        <RadioGroup.Label
          className={
            showHeading ? textVariants({ variant: headingVariant }) : 'sr-only'
          }
        >
          {heading} {required ? <RequiredSpan /> : null}
          {subheading ? <p className="text-body-3">{subheading}</p> : null}
        </RadioGroup.Label>
      ) : null}
      <div
        className={twMerge(
          clsx('flex flex-col gap-d md:gap-c lg:gap-b', {
            'items-start justify-start': variant === RadioButtonVariant.LEFT,
            'items-stretch': withImages,
            'pt-b': showHeading,
            'flex-row': orientation === RadioButtonOrientation.ROW,
          })
        )}
      >
        {options.map((option) => (
          <RadioButton
            key={option.id}
            option={option}
            variant={variant}
          />
        ))}
      </div>
    </RadioGroup>
  );
};

RadioButtonGroup.displayName = 'Radio Button Group';

export default RadioButtonGroup;
